document.addEventListener('DOMContentLoaded', handleQuantityLimitInMainCart);

async function isExceedingQuantity(quantityInput, quantityToAdd, quantityToSet) {
    const quantityWrap = quantityInput.closest('.quantity-wrap') || quantityInput.closest('.product-form')?.querySelector('.quantity-wrap');
    if (!quantityWrap) {
        return true;
    }
    let quantityLimit = quantityWrap.dataset.quantityLimit;
    const quantityLimitAlertMessage = quantityWrap.querySelector('.boa-quantity-limit-alert-message');
    if (!quantityLimit) {
        quantityLimitAlertMessage?.classList.add('hidden');
        return false;
    }
    let isLimit = true;
    quantityLimit = parseInt(quantityLimit);
    const productId = parseInt(quantityWrap.dataset.productId);
    if (quantityToAdd) {
        const products = await getCartItems();
        const existProductInCart = products.find(item => item.product_id === productId);
        isLimit = (existProductInCart?.quantity ?? 0) + quantityToAdd > quantityLimit;
    }
    else {
        isLimit = quantityToSet > quantityLimit;
    }
    isLimit ? quantityLimitAlertMessage?.classList.remove('hidden') : quantityLimitAlertMessage?.classList.add('hidden');
    return isLimit;
}

async function getCartItems() {
    const response = await fetch('/cart.js');
    const data = await response.json()
    return data.items;
}

function handleQuantityLimitInMainCart() {
    const quantityWrap = document.querySelectorAll(`${window.innerWidth >= 1200 ? '.line-item__quantity.hidden-phone .quantity-wrap:not([data-quantity-limit=""]) .quantity-plus' :
        '.line-item__quantity.hidden-tablet-and-up.quantity-wrap:not([data-quantity-limit=""]) .quantity-plus'}`)
    quantityWrap?.forEach(item => item.addEventListener('mousedown', (e) => {
        e.preventDefault();
        const quantityInput = e.target.closest('.quantity-selector').querySelector('.quantity-selector__input');
        if (!quantityInput) {
            return;
        }
        isExceedingQuantity(quantityInput, 1);
    }));
}